export const products = [
  {
    "id": "1763320012098",
    "name": "Hydrating Facial Cleanser",
    "category": "Cleanser",
    "brand": "CeraVe",
    "image": "https://res.cloudinary.com/dg8nuyybc/image/upload/v1763320040/product-images/ms9iikpzl1acarhputck.jpg",
    "price": null,
    "skin_concern": ["Dryness", "Sensitivity", "Barrier Support"],
    "description": "A gentle, hydrating cleanser by CeraVe, formulated with 3 essential ceramides and hyaluronic acid to cleanse without stripping the skin's natural moisture. Suitable for morning and evening use.",
    "usage": "Can be used daily, morning and evening.",
    "application": "For morning use, wet your face with lukewarm water, massage a small amount onto your skin in gentle, circular motions, then rinse and pat dry. For evening use as the second step of a double cleanse, use after an oil cleanser on a damp face.",
    "tips": "Avoid using hot water. When double cleansing, this step removes any remaining oily residue and water-based impurities."
  },
  {
    "id": "1763320056211",
    "name": "Ascorbic Acid 8% + Alpha Arbutin 2% A Water-Free, Stable Solution",
    "category": "Serum",
    "brand": "The Ordinary.",
    "image": "https://res.cloudinary.com/dg8nuyybc/image/upload/v1763320093/product-images/n04ng68vnmjlz0lpogfl.webp",
    "price": null,
    "skin_concern": ["Dullness", "Uneven Tone", "Dark Spots", "Antioxidant"],
    "description": "A water-free, stable solution from The Ordinary. combining 8% Ascorbic Acid (Vitamin C) and 2% Alpha Arbutin to target dullness, uneven tone, and pigmentation.",
    "usage": "Use daily in the morning.",
    "application": "Apply a few drops to the face after cleansing, before moisturizer and sunscreen.",
    "tips": "Vitamin C can make skin sensitive to the sun; always follow with sunscreen. Store in a cool, dark place."
  },
  {
    "id": "1763320106429",
    "name": "Hydro Boost Water Gel",
    "category": "Moisturizer",
    "brand": "Neutrogena",
    "image": "https://res.cloudinary.com/dg8nuyybc/image/upload/v1763320143/product-images/eefey8kbnfr0nnqnlyjn.webp",
    "price": null,
    "skin_concern": ["Dehydration", "Dryness", "Oily Skin"],
    "description": "A lightweight, oil-free water gel moisturizer from Neutrogena. Formulated with Hyaluronic Acid, Amino Acids, and Electrolytes to deliver oil-free hydration.",
    "usage": "Use daily in the morning.",
    "application": "Apply an even layer to the face and neck after serums.",
    "tips": "This lightweight gel formula works well under makeup without pilling."
  },
  {
    "id": "1763320169059",
    "name": "ANTHELIOS MELT-IN MILK SUNSCREEN 100 Body & Face Broad Spectrum SPF 100",
    "category": "Sunscreen",
    "brand": "LA ROCHE-POSAY",
    "image": "https://res.cloudinary.com/dg8nuyybc/image/upload/v1763320200/product-images/bq6itb4dila3a0xiswc1.webp",
    "price": null,
    "skin_concern": ["Sun Protection", "Anti-Aging"],
    "description": "A broad-spectrum SPF 100 sunscreen from La Roche-Posay with Cell-Ox Shield® technology and antioxidants. Designed for body and face.",
    "usage": "Use daily in the morning as the final step.",
    "application": "Apply generously to the face and neck 15 minutes before sun exposure. Reapply at least every 2 hours.",
    "tips": "Use the 'two-finger' rule to ensure you are applying enough product for your face and neck."
  },
  {
    "id": "1763320212966",
    "name": "Deep Cleansing Oil",
    "category": "Cleanser",
    "brand": "DHC",
    "image": "https://res.cloudinary.com/dg8nuyybc/image/upload/v1763320252/product-images/ylynchuuuqzuvii6qoff.webp",
    "price": null,
    "skin_concern": ["Makeup Removal", "Sunscreen Removal", "Clogged Pores"],
    "description": "A deep cleansing oil from DHC, famous for dissolving makeup, sunscreen, and impurities without clogging pores.",
    "usage": "Use daily in the evening. This is the first step of a double cleanse.",
    "application": "Dispense into dry hands and massage onto a dry face to break down makeup and sebum. Add lukewarm water to emulsify, then rinse thoroughly.",
    "tips": "Always follow with a water-based cleanser (like your CeraVe) to complete the double cleanse."
  },
  {
    "id": "1763320317208",
    "name": "Granactive Retinoid* 2% Emulsion",
    "category": "Serum",
    "brand": "The Ordinary.",
    "image": "https://res.cloudinary.com/dg8nuyybc/image/upload/v1763320361/product-images/djsfknbcpgfbbnkftbnz.webp",
    "price": null,
    "skin_concern": ["Fine Lines", "Wrinkles", "Anti-Aging", "Texture"],
    "description": "A 2% Granactive Retinoid emulsion from The Ordinary. This serum targets signs of aging, such as fine lines and texture, with lower irritation potential.",
    "usage": "Use daily in the evening.",
    "application": "Apply a few drops to the face in the PM after cleansing and before moisturizer.",
    "tips": "Retinoids increase sun sensitivity; always use sunscreen in the morning. If new to retinoids, start 2-3 times a week and build tolerance."
  },
  {
    "id": "1763320380325",
    "name": "PM Facial Moisturizing Lotion",
    "category": "Moisturizer",
    "brand": "CeraVe",
    "image": "https://res.cloudinary.com/dg8nuyybc/image/upload/v1763320424/product-images/irvm6az8xyhzmnjnk6oe.webp",
    "price": null,
    "skin_concern": ["Dryness", "Redness", "Barrier Repair"],
    "description": "CeraVe's PM Facial Moisturizing Lotion. Formulated with 3 essential ceramides, niacinamide, and hyaluronic acid to hydrate and calm the skin overnight.",
    "usage": "Use daily in the evening as the final step.",
    "application": "Apply an even layer to the face and neck after serums.",
    "tips": "The niacinamide in this lotion is great for calming redness and supporting the skin barrier."
  },
  {
    "id": "1763320438205",
    "name": "Glycolic Acid 7% Toning Solution",
    "category": "Toner",
    "brand": "The Ordinary",
    "image": "https://res.cloudinary.com/dg8nuyybc/image/upload/v1763320460/product-images/ejbsh4z75eaowuah7xbn.webp",
    "price": null,
    "skin_concern": ["Texture", "Dullness", "Uneven Tone"],
    "description": "A 7% Glycolic Acid toning solution from The Ordinary. This alpha-hydroxy acid (AHA) exfoliates the skin's surface to improve texture and boost radiance.",
    "usage": "Use weekly, in the evening.",
    "application": "After cleansing in the PM, apply to a cotton pad and sweep across the face and neck. Do not rinse.",
    "tips": "Do not use on the same night as your retinoid. Always use sunscreen the next day as AHAs increase sun sensitivity."
  },
  {
    "id": "1763320485754",
    "name": "Rare Earth Deep Pore Cleansing Masque",
    "category": "Mask",
    "brand": "Kiehl's",
    "image": "https://res.cloudinary.com/dg8nuyybc/image/upload/v1763320532/product-images/angdydcjlf4erhpft8hv.webp",
    "price": null,
    "skin_concern": ["Oily Skin", "Pores", "Blackheads"],
    "description": "A deep pore cleansing mask from Kiehl's, formulated with Amazonian White Clay to draw out impurities, reduce oil, and minimize the appearance of pores.",
    "usage": "Use weekly.",
    "application": "Apply a thin, even layer to clean, damp skin, avoiding the eye area. Let dry for 10-15 minutes, then remove with a warm, wet cloth.",
    "tips": "Do not let the mask dry completely and crack, as this can dehydrate the skin. Use on a different night than your exfoliating toner or retinoid."
  }
];
